module.exports = __webpack_public_path__ + "img/yusuf.cb8be2b6.jpg";